module.exports = __webpack_public_path__ + "img/slide4.084efe56.jpg";